<template>
    <Card title="Statuts Juridiques">
        <div
            v-for="(statutJuridique, index) in statutJuridiques"
            :key="index"
            class="flex place-content-between pr-20 mb-4"
        >
            <span
                ><p>{{ statutJuridique[0] }}</p></span
            >
            <span
                class="bg-orange-300 flex justify-center content-center rounded-full w-10 max-h-6"
                ><p>{{ statutJuridique[1] }}</p></span
            >
        </div></Card
    >
</template>

<script>
import Card from "../card";
export default {
    components: {
        Card
    },
    props: {
        statutJuridiques: {
            type: Map,
            required: true
        }
    }
};
</script>

<style></style>
